// How to use the String Module

// Step 1 : import this module as String, by destructuring will the locale supported
// e.g import { languageSetting } from './string';

// Step 2 : extrat string as constant by calling the function, languageSetting
// e.g const String = language(locale)
// If locale are not find or supported , it will automatically set as en (zh-hk)

export const string = {
  zh : {
    zh : '繁體中文',
    en : 'English',
    currency : 'HKD',
    subtitle : '企鵝科技',
    linkToAdminPanel : '進入管理平台',
    faandq : '常見問題',
    features : '系統功能',
    pricing : '即時報價',
    coverPitchHeader : '全港最抵餐飲 POS',
    coverPitchSubHeader : '每月 $50 HKD',
    pich1Header : '跨平台 一下載即用',
    pitch1Content : '比起傳統POS系統的設定，KIOS POS相對容易更多。客戶只需到Google Play Store 或 App Store下載KIOS POS的應用程式後，就可以立刻使用平板電腦或智能手機落單。配合BYOD (自攜裝置)，更可以節省更多設置成本。',
    pich2Header : '餐廳運作 流暢穩定',
    pitch2Content : '無論是樓面丶流程丶服務費丶員工丶打印機或是折扣我們都可以按照你現有的流程彈性設置。無論是落單丶查單丶刪單丶加單丶改單丶轉檯或是埋單，我們的系統都可照顧周到，確保餐廳運作流暢無誤。',
    linkToFeatures : '了解更多功能',
    pich3Header : '實時同步 管理分析',
    pitch3Content : '除了手機應用程式外，餐廳更可以使用我們的網上平台進行設置及分析。透過我們的雲端系統，餐廳可以即時掌握餐廳的表現，例如銷售情況丶產品報告等。所以即使你遠在天邊，但餐廳的管理都可以近在眼前。',
    caseHeader : '客戶案例 實事求事',
    coffeeGreenTea : '咖啡綠茶',
		coffeeGreenTeaAddress : '旺角萬高商業大廈3樓',
		cocina3 : 'Cocina 3 Bar and Restaurant',
		cocina3Address : '奧海城三期G22號舖',
    bumperCropMacauRes : '大豐澳門茶餐廳',
    neightborPrince : '梨巴王子甜品棧',
		fatTiger : '肥老虎美味屋',
		fatTigerAddress : '長沙灣集輝街2-8號地下1號舖',
    floorPlan : '樓面',
    menuItem : '餐牌項目',
    monthlyFee : '月費',
    caseFooter : '柯打已落單',
    priceHeader : '全港最抵 公開透明',
    hardware : '硬件',
    software : '軟件',
    service : '服務',
    hardwareDescription : '硬件採用一次性收費。價錢一般比市價低，有多款選擇。',
    softwareDescription : '手機應用程式 : $50 HKD / 月 / 平台。網上管理平台 : $100 HKD / 月',
    serviceDescription : '我們免費支援一次的上門教學和安裝服務。客戶亦可按需求要求更多服務，例如餐牌輸入等。',
    understandMoreAboutPrice : '了解更多收費詳情',
    trialPitchHeader : '蔗渣價錢 燒鵝味道',
    trialPitchSubHeader : '你還在等甚麼?',
    appliedFreeTrial : '免費試用軟硬件兩星期',
    contactMethod : '聯絡方法',
    email : 'admin@kios.tech',
    enquiryPhone : '24小時查詢熱線',
    phone : '58192522',
    address : '新蒲崗雙囍街同德工業大廈3B',
    copyRight : 'All COPY RIGHTS RESERVED BY KIOS TECH INT LTD @ 2016 - 2017',
    googlePlayStoreUrl : 'https://play.google.com/store/apps/details?id=com.tech.kios',
    iosAppStoreUrl : 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1194933509&mt=8',
    mobileDevices : '手機或平板應用程式',
    webAppDashboard : '網上管理平台',
    menu : '餐牌',
    setting : '設定',
    summary : '埋數',
    summaryDesc : '管理員可選擇指定的時間和日期，列印出一張綜合的時段營業額流水帳。管理員亦可印列單一帳單。',
    addInvoice : '落單',
    addInvoiceDesc : '一般樓面的落單功能。在先進餐後付款的流程下(一般有堂食服務的餐廳)，先選擇樓面檯號，再選擇餐牌項目，然後再確定送單。在先付款後進餐的流程下(小食店丶快餐店)，在選擇選擇餐牌項目後，可直接確定送單。',
    amendInvoice : '加或改單',
    amendInvoiceDesc : '在落單後，客人很多時候會再加單或改單。待應可運用加/改單功能，輕鬆完成指令。',
    deleteInvoice : '刪單',
    deleteInvoiceDesc : '若因任何特殊情況下，需將整張單刪除，可使用此功能。',
    changeTable : '轉檯',
    changeTableDesc : '落客人需由一張檯轉到另一張檯，可使用此功能。在轉檯後，樓面打印機會額外重新列印一張點餐紙作為依據。',
    checkoutInvoice : '埋單',
    checkoutInvoiceDesc : `在進餐後，如客人需要結帳，可使用此功能。在輸入付款金額後，系統會自動計算找續全額，收銀櫃亦會自動彈出，方便找續流程。在先進餐後付款的流程下(一般有堂食服務的餐廳)，
    我們的系統亦可配合到自助式和服務式的付款流程。`,
    shareTable : '撘檯',
    shareTableDesc : '如撘檯的情況出現，可使用此功能。如檯號是1的話，單號會按照1a,1b,1c,1d....如此類推自動排列。',
    menuDesc : 'KIOS POS 的餐牌主要分為4個層次 : 餐牌丶分類丶項目和選項。餐牌是最上層的分類，例如可按時間劃分，分為早餐丶午餐丶晚餐。',
    category : '分類',
    catDesc : '在餐牌之下，例如早餐和再分類為全日早餐丶特色早餐和歐陸早餐。',
    item : '項目',
    itemDesc : '在分類之下，例如在歐陸早餐下，可以有牛扒蛋和雞扒蛋兩個項目。每個項目可分流到指定的打印機，例如飲品可分流到水吧，食品可分流到廚房打印。另外，每個項目亦可設定獨立的匿稱，例如檸水的匿稱可設定為0水，方便廚房辨識。',
    option : '選項',
    optionDesc : '在項目之下，例如在牛扒蛋下，可以有炒蛋和太陽蛋，兩個不同的選項。選項一般的作用是用來標示項目的一些口味選擇或附加條件。',
    set : '套餐',
    setDesc : 'KIOS POS系統預設智能配餐功能，可自動根據不同的套餐規則修改項目價錢。',
    restaurant : '餐廳',
    restaurantDesc : '設定餐廳名稱丶地址和聯絡方法定基本資料，用作打印收據抬頭。',
    workflow : '流程',
    workFlowDesc : '設定餐廳的運作流程。KIOS POS可配合不同飲食業者的運作流程，不論是一般先進餐後付款的餐廳(堂食服務)，還是先付款後進餐的餐廳(小食店丶快餐店)都可以配合到',
    staff : '員工',
    staffDesc : 'KIOS POS有兩種不同限權的身份 : 管理員和員工。管理員擁有系統的都大限權，可以設定和檢視餐廳的所有資料。而員工只可檢視到餐廳一般樓面運作的資料',
    serviceCharge : '服務費',
    serviceChargeDesc : '服務費可分為劃一和時段性兩種。劃一服務費在結帳時將單據乘一個固定的百分比。而時段性服務費則會局限於某個指定時段下服務費才生效。',
    discount : '折扣',
    discountDesc : '在設定折扣後，在結帳時可將指定的折扣優惠應用到全張單或是個別項目。',
    printer : '打印機',
    printerDesc : 'KIOS POS的打印機主要有四種打印功能:食物項目丶樓面丶收銀和埋數。使用者可將多種不同的功能分配到單一的打印機，以方便彈性配合不同的流程。另外在打印格式方面，使用者亦可因應自己的需求設定字體的大小丶合併打印和價錢顯示。',
    floorPlanDesc : 'KIOS POS的餐檯管理方便易用，使用者可按自己的需要設定不同的分區和檯號。',
    analytic : '分析',
    devices : '裝置',
    deviceDesc : '可以監察正在使用KIOS POS系統的裝置(手機或平板)，確保系統安全正常。',
    realTimePerf : '即時表現',
    realTimePerfDesc : '透過網上管理平台，管理員可實時監察餐廳的表現和狀況。即使遠在天邊，餐廳管理亦變得近在眼前。',
    salesReport : '銷售報告',
    salesReportDesc : '綜合了餐廳不同日期和時段的表現，和透過不同圖表分析餐廳未來的益利和情況。',
    productReport : '產品報告',
    productReportDesc : '以排行榜方式列出熱門售銷項目，更看見全盤走勢。甚至是調整特定餐品定價後，對其他餐品銷量的影響。透過產品報告，客戶能更有效地調整餐牌項目。',
    noFeatureSelected : '講選擇相關功能',
    signupNow : '立即註冊',
		sunmiSeries : '商米糸列',
		sunmiV1 : '商米V1 + 充電座',
		sunmiV1Price : 2500,
		sunmiV1Desc : '二合一POS落單機。5.5英寸IPS qHD。CPU:1.3GHz四核。Android 5.1。電池7.4V/5200 mAh。3G/Wifi自動切換。內置58mm熱敏打印機。尺寸 : 218mm(長) x 89.2mm(闊) x 57.9mm(高)。',
		sunmiM1 : '商米M1 + 充電座',
		sunmiM1Price : 1500,
		sunmiM1Desc : 'POS落單手機。4.5英寸IPS。CPU:1.3GHz四核。Android 5.1。電池3.7V/3000 mAh。3G/Wifi自動切換。尺寸 : 148mm(長) x 73mm(闊) x 23mm(高)。',
		sunmiT1 : '商米T1',
		sunmiT1Price : 3500,
		sunmiT1Desc : '二合一POS終端機。14寸分辨率FHD1920X1080。Qualcomm® Snapdragon八核處理器。Android 6。3G/Wifi自動切換。內置80mm熱敏打印機，帶切刀。尺寸 : 224mm(長) x 338mm(闊) x 374mm(高)。',
    posTerminal : 'POS 終端機',
    WifiThermalPrinter58mm : '58mm WIFI熱敏打印機',
    WifiThermalPrinter58mmPrice : 1650,
    WifiPrinterDesc : '帶自動切動。利用WIFI進行數據傳輸，適合有無線網絡的店鋪。',
    WifiThermalPrinter80mm : '80mm WIFI熱敏打印機',
    WifiThermalPrinter80mmPrice : 1850,
    WifiDotMatrixPrinter76mm : '76mm WIFI針式打印機',
    WifiDotMatrixPrinter76mmPrice : 2000,
    EthernetPrinterDesc : '帶自動切動。利用以太網進行數據傳輸，適合已進行拉線工程的店鋪。',
    EthernetThermalPrinter58mm : '58mm 有線熱敏打印機',
    EthernetThermalPrinter58mmPrice : 1650,
    EthernetThermalPrinter80mm : '80mm 有線熱敏打印機',
    EthernetThermalPrinter80mmPrice : 1850,
    EthernetDotMatrixPrinter76mm : '76mm 有線針式打印機',
    EthernetDotMatrixPrinter76mmPrice : 2000,
    DualMonitorPOS12inch : '12寸雙屏POS終端機',
    DualMonitorPOS12inchPrice : 2000,
    DualMonitorPOS15inch : '15寸雙屏POS終端機',
    DualMonitorPOS15inchPrice : 4000,
    DualMonitorDesc : '雙屏POS終端機。外屏可用作顯示價錢和廣告，內屏可用作點餐。另外配備USB,OTG(Micro USB),以太網等接口，方便不同配置。適合小食店丶快餐店使用。',
    SingleMonitorPOS15inch : '15寸單屏POS終端機',
    SingleMonitorPOS15inchPrice : 3000,
    SingleMonitorDesc : '單屏POS終端機。另外配備USB,OTG(Micro USB),以太網等接口，方便不同配置。適合小食店丶快餐店使用。',
    cashDrawerAuto : '收銀櫃 (自動)',
    cashDrawerAutoPrice : 500,
    cashDrawerDesc : '長(420mm) x 闊(405mm) x 高 (110mm)。三種模式(自動，鎖定，鑰匙檔)，五格空間，包括支票入口。可配合KIOS POS使用。',
    cashDrawer : '收銀櫃',
    price : '價錢',
    quotePrice : '即時報價',
    noItem : '沒有項目',
    month : '月',
    mobileAppLicense : '手機/平板電腦/POS終端機APP',
    mobileAppDesc : '可在Android 4.2.0 或以上和 IOS 7 以上的手機丶平板或POS終端機運作。主要用作日常餐廳運作。每個許可權(License)只可在一個指定裝置上運作。至少簽約12個月 ($50 HKD x 12 = $600 HKD)。',
    webAppAppLicense : '網上管理平台',
    webAppDesc : '可在任何電腦的遊覽器上使用(建議使用Chrome)。主要用作設定餐廳流程和分析餐廳表現。至少簽約12個月 ($100 HKD x 12 = $1200 HKD)。',
    basicCs : '基本售後支援',
    basicCsDes : '包括基本電話丶電郵及Facebook文字訊息技術支援 (星期一至五 : 9 : 00 - 17 :00)。包括一次預約教學講座 (60分鐘)。',
    premiumCs : '尊貴售後支援',
    premiumCsDes : '包括基本電話丶電郵及Facebook文字訊息技術支援 (星期一至日 : 9 : 00 - 17 :00)。包括緊急技術支援 (星期一至日 : 17 : 00 - 22 :00)。包括一次預約上門安裝及教學服務 (120分鐘)。',
    invoicePrice : '總單價',
    laterCount : '後計',
		sunmiPrinter : '58mm 一體熱敏打印機',
		sunmiAndroid : '5.5寸安卓手機',
		sunmiVolumeShortcut : '自訂側按快捷鍵指令',
		sunmiCamera : '0.7秒 QR Code / Barcode 掃描',
		pitch0Header : '手機 + 打印機 = POS神器',
		pitch0Content : '集合打印機和手機於一身。落單後直接印單，減少來回時間，大大有效節省時間成本，實為POS業界的最大突破。',
		sunmiAndroidVer : '5.1 安卓糸統',
		sunmiScreen : '5.5寸 IPS 屏幕',
		sunmiBattery : '48小時電量',
		sunmiPrint : '75 mm/s 打印',
		sunmiConnect : '3G/Wifi 自動切換',
		csvDownload : 'CSV/Excel 下載',
		cloudStorage : '雲端儲存',
		resAddress : '地址',
		close : '關閉',
		dPayPitchHeader : '會幫你賺錢的POS',
		dPayPitchContent : 'Kios POS 不單是一個提高生產效率的POS，更可以幫你先賺未來錢。透過我們的充值功能，商戶可以安全快捷地發行屬於你的現金券。客人亦可以下載"dPay 抵比"手機應用程式，使用現金券完成交易。',
		learnTopUp : '了解充值功能',
		instantPrint : '充值 - 即印即用',
		qrCodeTransaction : '交易 - QR Code掃描',
		noFunction : '沒有此功能',
		whatIsDPay : '會賺錢的POS - 甚麼是現金券充值?',
		dPayDesc1 : '透過Kios POS 的現金券充值功能，商戶可以輕易地發行屬於自己的現金券或優惠。而這些現金券主要分為兩種 :',
		freeTopUp : '免費 : 現金券優惠',
		freeTopUpDesc : '免費優惠主要用作宣傳推廣，透過大量派發，吸引更多顧客來消費',
		payTopUp : '收費 : 現金券充值(食飛)',
		payTopUpDesc : '收費充值主要透過以折扣形式，將現金券賣給顧客，讓顧客留待日後消費使用，亦即"食飛"也。透過現金券買賣，商戶可先賺未來錢，爭取更多現金流',
		dPayDesc2 : '與傳統發行現金券的流程相比，Kios POS的充值功能節省了印刷丶設計丶核對丶驗證及防偽等繁複流程，大大降低了發行成本。',
		dPayTopUp : '實際運作 - 充值',
		dPayTopUpDesc1 : '要使用現金券充直功能，用戶可以按樓面介面右上角的QR Code標誌。',
		dPayTopUpDesc2 : '商戶可以分別透過三個不同方法替客戶充值 : 列印現金券丶QR Code掃描或電郵充值。',
		dPayTopUpDesc3 : '如使用列印現金券的方法，商戶的打印機將會列印一張充值券出來。充值券上會詳細列明交易金額丶發行單位及充值方法，客戶將透過下載dPay 抵比手機應用程式完成所有的充值程序。',
		step1 : '第一步',
		step2 : '第二步',
		step3 : '第三步',
		dPayRedeem : '實際運作 - 兌現使用',
		dPayRedeemDesc1 : '在結帳時，如果客戶要使用dPay現金券，商戶可以先按結帳介面右上角的Qr Code標誌。',
		dPayRedeemDesc2 : '結帳介面將會顯示一個代表商戶的QR Code，可以供客戶透過"dPay 扺比"手機應用程式中的掃描功能來確認付款。',
		dPayRedeemDesc3 : '在客戶確定使用現金券後，相關帳單將自動扣除現金劵的銀碼，然後再按正常的結帳程序找續。',
		dPayTopUpRule : '實際運作 - 充值規則',
		dPayTopUpRuleDesc1 : '商戶可到設定介面，然後按現金券進行設定。',
		dPayTopUpRuleDesc2 : '商戶可設定現金券的面值和價值，系統會自動計算兌換率。',
		dPayApp : 'dPay 抵比手機應用程式',
		dPayMobileAppDesc1 : 'dPay 抵比手機應用程式，是企鵝科技POS官方指定給客戶用現金券交易的唯一渠道。如欲知道更多詳情，請到dPay的官方網站。',
		dPayWebsite : 'dPay官方網站'
  },
  en : {
    zh : '繁體中文',
    en : 'English',
    currency : 'USD',
    linkToAdminPanel : 'Dashboard Login',
    faandq : 'Frequent Ask Questions',
    features : 'Features',
    pricing : 'Pricing',
    coverPitchHeader : 'A Smarter Cloud-Based POS System',
    coverPitchSubHeader : '',
    pich1Header : 'Cross Platform , Bring Your Own Devices',
    pitch1Content : 'Compared to the traditional POS system, KIOS POS setup is relatively easy. Customers only need to download the KIOS POS app from the Google Play store or the App Store to sign up for a tablet or smartphone. Under Bring Your Own Device (BYOD) policy, restaurant owners also can save more setup costs.',
    pich2Header : 'Operations, Smooth and Stable',
    pitch2Content : 'Whether it is floor management, workflow, service charges, staffs, printers, or discounts, we are flexible to fit your own needs. Whether it is a placing orders, checking orders, deleteing orders, amending orders or checking the bill, our system can ensure the smooth operation of under your finger tips.',
    linkToFeatures : 'Learn more about the features',
    pich3Header : 'Instant Synchronize, Real Time Management',
    pitch3Content : "In addition to mobile apps, restaurants can be set up and analyzed using our online dashboard. Through our cloud system, restaurant owner can immediately grasp the restaurant's performance, such as sales, product reports and so on. Restaurant management can be near the front.",
    caseHeader : 'Customers Testimonial',
    coffeeGreenTea : 'Coffee Green Tea',
		coffeeGreenTeaAddress : '3/F, Michealson House, 38-49 Sai Yeung Choi Street South, Mong Kok',
    bumperCropMacauRes : 'Bumper Crop Macau Restaurant',
    neightborPrince : 'Neightbor Prince Dessert',
		cocina3 : 'Cocina 3 Bar and Restaurant',
		cocina3Address : 'Shop G22, G/F, Olympian City 3, 1 Hoi Wang Road, Tai Kok Tsui',
		fatTiger : 'Fat Tiger Restaurant',
		fatTigerAddress : 'Shop 1, G/F, 2-8 Tsao Fai Street, Cheung Sha Wan',
    floorPlan : 'Floor Plan',
    menuItem : 'Number of Menu Items',
    monthlyFee : 'Monthly Fee',
    caseFooter : 'Orders Processed',
    priceHeader : 'Pricing , Open and Flexible',
    hardware : 'Hardware',
    software : 'Software',
    service : 'Services',
    hardwareDescription : 'One-off Payment , lower than marketing price.',
    softwareDescription : 'Fixed license fees per month , no hidden cost.',
    serviceDescription : 'Free after sales remote support.',
    understandMoreAboutPrice : 'Know more about the pricing',
    trialPitchHeader : 'Great Value, Great Price',
    trialPitchSubHeader : 'What are you waiting for ?',
    appliedFreeTrial : 'Free Trial for Two Weeks',
    contactMethod : 'Contact',
    email : 'admin@kios.tech',
    enquiryPhone : '24 Hours Hotline',
    phone : '+852-58192522',
    address : 'Block B, 3/F, Tontex Industrial Building, 2-4 Sheung Hei Street, San Po Kong, Kowloon',
    copyRight : 'All COPY RIGHTS RESERVED BY KIOS TECH INT LTD @ 2016 - 2017',
    googlePlayStoreUrl : 'https://play.google.com/store/apps/details?id=com.tech.kios',
    iosAppStoreUrl : 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1194933509&mt=8',
    mobileDevices : 'Mobile Applications',
    webAppDashboard : 'Online Dashboard',
    menu : 'Menu',
    setting : 'Setting',
    summary : 'Summary',
    summaryDesc : 'The administrator can select a specific time and date to print out an integrated time period turnover ledger. Administrators can also print a single bill.',
    addInvoice : 'Place Orders',
    addInvoiceDesc : 'Handle basic function to place orders for customers.',
    amendInvoice : 'Amend Invoice',
    amendInvoiceDesc : 'After placing the orders, customers may want to amend some of the items.',
    deleteInvoice : 'Delete Invoice',
    deleteInvoiceDesc : 'Under special circumstance, staff can void and delete the whole invoice.',
    changeTable : 'Change Table',
    changeTableDesc : 'Customer may want to change to different table when they are dinning. An extra receipt will prin out after changeing table to update the correct table number.',
    checkoutInvoice : 'Checkout',
    checkoutInvoiceDesc : 'After finish the meal, when customer checkout, waiter can input the payment amount and calculate the change amount.',
    shareTable : 'Share Table',
    shareTableDesc : 'If customers share a table, invoice number will arrange in order according to the alphabet, for example, 1a,1b,1c,1d...',
    menuDesc : 'KIOS POS menu system has four major levels : menu , category , item and option. Menu is the at the top of the hierarchy, for example , we can have drink and food menu.',
    category : 'Category',
    catDesc : 'Under menu level, for example, under drink menu , we can have coffe and tea category.',
    item : 'Item',
    itemDesc : 'Under categories level, for example, under coffee category, we can have Mocha and Americano item. Each item can be printed out at a specific printer according to your needs and preference. Also , an alias can be set for each item.',
    option : 'Option',
    optionDesc : 'Under items level , we have got options level. It can be used to adjust the favour or taste preference of a customer. For example, you can wither choose a Hot Option or Cold Option for the Americano Item.',
    set : 'Set',
    setDesc : 'KIOS POS has smart set matching mechanism according to different set rules.',
    restaurant : 'Restaurant Info',
    restaurantDesc : 'Setting the restaurant name, address and contact number. Mainly use as the header of the printing receipt.',
    workflow : 'Workflow',
    workFlowDesc : 'Setting restaurant workflow。KIOS POS can fit into different restaurant workflow, no matter it is a seat-in restaurant or a fast food shop.',
    staff : 'Staff',
    staffDesc : 'There are two authority role in KIOS POS : Admin and Staff. Admin role can access all the information in the system while staff can only access data for daily operations.',
    serviceCharge : 'Service Charge',
    serviceChargeDesc : 'There are two types of service charges in our system : Standard charge rate or sectional charge rate.',
    discount : 'Discount',
    discountDesc : 'Discount can be applied to whole invoice or individual items only.',
    printer : 'Printer',
    printerDesc : 'KIOS POS printer has four major functions : Printing food orders,printing invoice,printing receipt and prinitng summary. Restaurant owner can assigned multiple functions to a specific printer according to their own needs. Printing format can also easily adjusted, for instant, the font size on the receipt.',
    floorPlanDesc : 'KIOS POS floorplan management is easy to use, restaurant owners can set different partitions and station number according to their needs.',
    analytic : 'Analytic',
    devices : 'Device',
    deviceDesc : 'Monitoring the mobile devices or tavblet that are using your system.',
    realTimePerf : 'Real Time Performance',
    realTimePerfDesc : 'Monitoring the restaurant performance in real time.',
    salesReport : 'Sales Report',
    salesReportDesc : 'Showing the revenue and sales under a specific time and period which enable you for profit analytic.',
    productReport : 'Product Report',
    productReportDesc : 'Listing popular selling items, see the overall trend. Track the effect of adjusting the price of certain food items, and the impact of other food sales. Through product reports, restaurant owner can more effectively adjust their menu items.',
    noFeatureSelected : 'Please Select a Feature',
    signupNow : 'Sign Up',
		sunmiSeries : 'Sunmi Series',
		sunmiV1 : 'Sunmi V1 + Charging Base',
		sunmiV1Price : 300,
		sunmiV1Desc : '2 in 1 POS Android Device. 5.5 inches IPS qHD. CPU:1.3GHz Quadcore. Android 5.1. Battery 7.4V/5200 mAh. 3G/Wifi Auto Switch. Internal 58mm Thermal Printer. Size : 218mm(Length) x 89.2mm(Width) x 57.9mm(Height).',
		sunmiM1 : 'Sunmi M1 + Charging Base',
		sunmiM1Price : 200,
		sunmiM1Desc : 'POS Android Device. 4.5 inches IPS. CPU:1.3GHz Quadcore. Android 5.1. Battery 3.7V/3000 mAh. 3G/Wifi Auto Switch. Size  : 148mm(Length) x 73mm(Width) x 23mm(Height).',
		sunmiT1 : 'Sunmi T1',
		sunmiT1Price : 500,
		sunmiT1Desc : '2 in 1 POS Terminal. 14 inches FHD1920X1080. Qualcomm® Snapdragon Qutocore. Android 6. 3G/Wifi Auto Switch. Internal 80mm Thermal Printer，Auto Cutter. Size : 224mm(Length) x 338mm(Width) x 374mm(Height).',
    posTerminal : 'POS Terminal',
    WifiThermalPrinter58mm : '58mm WIFI Thermal Printer',
    WifiThermalPrinter58mmPrice : 'TBC',
    WifiPrinterDesc : 'Using WIFI for data transmission, suitable for restaurant with wireless network.',
    WifiThermalPrinter80mm : '80mm WIFI Thermal Printer',
    WifiThermalPrinter80mmPrice : 'TBC',
    WifiDotMatrixPrinter76mm : '76mm WIFI Dot Matrix Printer',
    WifiDotMatrixPrinter76mmPrice : 'TBC',
    EthernetPrinterDesc : 'Using Ethernet for data transmission, suitable for restaurant with cable construction work',
    EthernetThermalPrinter58mm : '58mm Ethernet Thermal Printer',
    EthernetThermalPrinter58mmPrice : 'TBC',
    EthernetThermalPrinter80mm : '80mm Ethernet Thermal Printer',
    EthernetThermalPrinter80mmPrice : 'TBC',
    EthernetDotMatrixPrinter76mm : '76mm Ethernet Dot Matrix Printer',
    EthernetDotMatrixPrinter76mmPrice : 'TBC',
    DualMonitorPOS12inch : '12inch Single Display POS Terminal',
    DualMonitorPOS12inchPrice : 'TBC',
    DualMonitorPOS15inch : '15inch Dual Display POS Terminal',
    DualMonitorPOS15inchPrice : 'TBC',
    DualMonitorDesc : 'Dual Display POS Terminal。External Display can use for price showing or advertising while Internal Display can use for placing orders。With USB,OTG(Micro USB),Thernet，suitable for different kind of restaurant and snack shop.',
    SingleMonitorPOS15inch : '15inch Single Display Terminal',
    SingleMonitorPOS15inchPrice : 'TBC',
    SingleMonitorDesc : 'Single Display POS Terminal。With USB,OTG(Micro USB),Thernet，suitable for different kind of restaurant and snack shop.',
    cashDrawerAuto : 'Cash Drawer (Auto)',
    cashDrawerAutoPrice : 'TBC',
    cashDrawerDesc : 'Length (420mm) x Width (405mm) x Height (110mm)。Three Mode (Auto，Lock，Manual)。Perfect to work with POS System。',
    cashDrawer : 'Cash Drawer',
    price : 'Price',
    quotePrice : 'Quote Price',
    noItem : 'No Items',
    month : 'Month',
    mobileAppLicense : 'Mobile / Table / POS Terminal Applications',
    mobileAppDesc : 'Compatible with Android 4.2.0 or above and IOS 9 or above Mobile Devices, Tablet and POS Terminal.Mainly use for daily operations of a restaurant.',
    webAppAppLicense : 'Online Dashboard',
    webAppDesc : 'Work on any brower on computer ( Chrome is recommanded )。Mainly use for analytic and setting.',
    basicCs : 'Basic Support',
    basicCsDes : 'Including email, text message and phone support.',
    premiumCs : 'Premium Support',
    premiumCsDes : 'Including email, text message and phone support.',
    invoicePrice : 'Total Price',
    laterCount : 'To Be Confirmed',
		sunmiPrinter : 'All-in-one 58mm Thermal Printer',
		sunmiAndroid : '5.5 inches Android Devices',
		sunmiVolumeShortcut : 'Customizable Side Key Command',
		sunmiCamera : '0.7 second QR Code / Barcode Scanning',
		pitch0Header : 'Android + Thermal Printer = Best POS Device',
		pitch0Content : 'Breakthrough design by combing Android and Thermal Printer. Efficiency of POS usage will be enhanced. Saving more money by saving more time.',
		sunmiAndroidVer : '5.1 Android Version',
		sunmiScreen : '5.5 inches IPS Screen',
		sunmiBattery : '48 Hours Battery Life',
		sunmiPrint : '75 mm/s Printing Speed',
		sunmiConnect : '3G/Wifi Auto Switch',
		csvDownload : 'CSV/Excel Export',
		cloudStorage : 'Cloud Storage',
		resAddress : 'Address',
		close : 'Close',
		dPayPitchHeader : 'A Profitable POS',
		dPayPitchContent : 'Kios POS not only can improve your productivity , but also can help you make more profit. By making use of our Top Up function, merchant can distribute cash coupon in an easy and secure way. Customer can redeem the Cash Coupon seamlessly by using dPay App during checkout .',
		learnTopUp : 'Learn Top Up Feature',
		instantPrint : 'Top Up - Instant Print Out',
		qrCodeTransaction : 'Redeem - QR Code Scan',
		noFunction : 'No Such Funtion',
		whatIsDPay : 'A Profitable POS - What is Cash Top Up ?',
		dPayDesc1 : 'By making use of the top up function , mechant can easily distribute their own cash coupon (top up). There are two main types of top up : ',
		freeTopUp : 'Free Coupon',
		freeTopUpDesc : 'Mainly use for promotion purpose. By massive distribution , more customer can be attracted.',
		payTopUp : 'Paid Top Up',
		payTopUpDesc : 'Paid top up is distributed to customer at a certain discount rate while customer pay for it in advance. As a result, merchant can retain and secure more cash flow in their business .',
		dPayDesc2 : 'Compare to the traditional procedure of coupon distribution, our top up function can save you much more time and cost. Printing , design , verifying and security cost can be saved.',
		dPayTopUp : 'Operation - Top Up',
		dPayTopUpDesc1 : 'To use the top up function , merchant can click the QR Code icon on the right hand corner of the floor plan interface.',
		dPayTopUpDesc2 : 'Merchant can distribute the top up coupon in three different ways : printing , scanning and mailing. ',
		dPayTopUpDesc3 : 'If printing method is used, thermal printer will print out a top up coupon. This coupon will list out the distribution entity , top up method and top up amount. Customer can easily finish the top up procedure by following the instruction on the print out. ',
		step1 : 'Step 1',
		step2 : 'Step 2',
		step3 : 'Step 3',
		dPayRedeem : 'Operation - Redeem',
		dPayRedeemDesc1 : 'During Checkout , if customer want to use the dPay top up , you can press the QR icon on the right hand corner of the checkout interface.',
		dPayRedeemDesc2 : 'A QR Code which represent the merchant will be shown on the interface, please let customer to scan this Qr Code by using the dPay Mobile App.',
		dPayRedeemDesc3 : 'After Customer confirm the redeem by the dPay app , related invoice will be discounted according to the top up amount. ',
		dPayTopUpRule : 'Operation - Top Up Rule',
		dPayTopUpRuleDesc1 : 'Merchant can go to the setting page and press cash coupon setting. ',
		dPayTopUpRuleDesc2 : 'Merchant can set the Present Value and Face Value of a top up rule which can be reused during top up distribution. Exchange rate will be calculated automatically. ',
		dPayApp : 'dPay Mobile App',
		dPayMobileAppDesc1 : 'dPay Mobile Application is the official mobile application for Customer to claim and redeem their top up under the POS System. For more detail , please checkout dPay official website. ',
		dPayWebsite : 'dPay Website'
  }
}

export const locationCoordinates = {
  zh_hk : { latitude : 22.2855200 , longitude : 114.1576900 }
}

export function languageSetting(localeSetting){
  return (typeof string[localeSetting] !== 'undefined') ? string[localeSetting] : string['zh'] ;
}



/** WEBPACK FOOTER **
 ** ./src/constants/string.js
 **/